import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterSSDIPageDatasetCreate = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("ssdi/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.CreateDatasetPage />,
        });
      })
      .catch(reject);
  });
});

export const LazySSDIPageDatasetCreate = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterSSDIPageDatasetCreate />
    </Suspense>
  );
};
